import { RequestFilterModel } from '../../shared/models/requestFilterModel';

export class UserRestore {
  static readonly type = '[Merchant] Restore User';
}

export class Login {
  static readonly type = '[Merchant] Login';
  constructor(public card: string, public pin: string) {}
}

export class Logout {
  static readonly type = '[Merchant] Logout';
}

export class GetMerchantDetails {
  static readonly type = '[Merchant] Get Card Details';
}

export class GetTransactionList {
  static readonly type = '[Merchant] Get Transaction List';
}

export class GetMoreTransactionListItems {
  static readonly type = '[Merchant] Get More Transaction List Items';
}

export class GetTransactionDetails {
  static readonly type = '[Merchant] Get Transaction Details';
  constructor(public transactionId: string) {}
}

export class GetCashcutList {
  static readonly type = '[Merchant] Get Cashcut List';
}

export class GetMoreCashcutListItems {
  static readonly type = '[Merchant] Get More Cashcut List Items';
}

export class GetCashcutDetails {
  static readonly type = '[Merchant] Get Cashcut Details';
  constructor(public cashcutId: string) {}
}

export class SetRequestFilter {
  static readonly type = '[Merchant] Set Request Filter';
  constructor(public filter: RequestFilterModel) {}
}

export class UpdatePin {
  static readonly type = '[Merchant] Update PIN';
  constructor(public oldPassword: string, public newPassword: string) {}
}

export class UpdateEmail {
  static readonly type = '[Merchant] Update Email';
  constructor(public newEmail: string) {}
}
